/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $GoalTypeAmount = {
    properties: {
        key: {
            type: 'any-of',
            contains: [{
                type: 'GoalTypeEnum',
            }, {
                type: 'null',
            }],
            isRequired: true,
        },
        amount: {
            type: 'number',
            isRequired: true,
        },
    },
} as const;
